/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageMetadata } from './PageMetadata';
import {
    PageMetadataFromJSON,
    PageMetadataFromJSONTyped,
    PageMetadataToJSON,
    PageMetadataToJSONTyped,
} from './PageMetadata';
import type { WorkDTO } from './WorkDTO';
import {
    WorkDTOFromJSON,
    WorkDTOFromJSONTyped,
    WorkDTOToJSON,
    WorkDTOToJSONTyped,
} from './WorkDTO';

/**
 * 
 * @export
 * @interface PagedModelWorkDTO
 */
export interface PagedModelWorkDTO  {
    /**
     * 
     * @type {Array<WorkDTO>}
     * @memberof PagedModelWorkDTO
     */
    content?: Array<WorkDTO>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelWorkDTO
     */
    page?: PageMetadata;
}

/**
 * Check if a given object implements the PagedModelWorkDTO interface.
 */
export function instanceOfPagedModelWorkDTO(value: object): value is PagedModelWorkDTO {
    return true;
}

export function PagedModelWorkDTOFromJSON(json: any): PagedModelWorkDTO {
    return PagedModelWorkDTOFromJSONTyped(json, false);
}

export function PagedModelWorkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedModelWorkDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(WorkDTOFromJSON)),
                  'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}

export function PagedModelWorkDTOToJSON(json: any): PagedModelWorkDTO {
    return PagedModelWorkDTOToJSONTyped(json, false);
}

export function PagedModelWorkDTOToJSONTyped(value?: PagedModelWorkDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(WorkDTOToJSON),
        'page': PageMetadataToJSON(value['page']),
    };
}


